export type ChatAboutFeedbackDetail = {
  context?: string;
  tone?: "success" | "gentle" | "neutral";
};

export function buildChatAboutFeedbackMessage(detail: ChatAboutFeedbackDetail = {}): string {
  const context = detail.context?.trim();
  if (!context) {
    return "Can you help me understand the feedback on my last answer?";
  }
  return `I received this feedback on my answer:\n\n"${context}"\n\nCan you help me understand what it means and what I should practice?`;
}

/** Dispatched now; AgentOverlayProvider subscribes and opens the tutor chat. */
export function requestChatAboutFeedback(detail: ChatAboutFeedbackDetail = {}): void {
  if (typeof window === "undefined") return;
  window.dispatchEvent(
    new CustomEvent<ChatAboutFeedbackDetail>("convo:chat-about-feedback", {
      detail,
    }),
  );
}
